import { render, staticRenderFns } from "./CollectionUnit.vue?vue&type=template&id=68eeb8d0"
import script from "./CollectionUnit.vue?vue&type=script&lang=js"
export * from "./CollectionUnit.vue?vue&type=script&lang=js"
import style0 from "./CollectionUnit.vue?vue&type=style&index=0&id=68eeb8d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports